import React from "react";
import Terminal from "./terminal";

function Cover() {
  return React.createElement(
    "section",
    { id: "cover", className: "cover section" },
    React.createElement(
      "div",
      { className: "cover-main" },
      React.createElement(
        "h1",
        { className: "cover-title" },
        "VAN'S",
        React.createElement("br"),
        React.createElement("span", { className: "accent" }, "PORTFOLIO"),
      ),
      React.createElement(
        "p",
        { className: "cover-subtitle" },
        "Developer & video editor building user-centric apps, AI-enhanced tools, and stories worth watching.",
      ),
      React.createElement("div", { className: "scroll-cue" }, "\u2193 scroll"),
    ),
    React.createElement(
      "div",
      { className: "cover-side" },
      React.createElement(Terminal),
    ),
  );
}

export default Cover;
